(ns manage.content-variant-page.entities.tracker.db
  (:require [clojure.string :as str]
            [common.util :as util]
            [mate.core :as mc]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(defn value-to-save [db]
  (->> (::tracker-params db)
       (filterv (comp not str/blank? :value))))

(defn content-has-changed? [db]
  (let [value-in-resource (-> db :resource.adset/one :value :trackers)]
    (not= value-in-resource (value-to-save db))))

(rf/reg-sub ::tracker-params
  (fn [db _]
    (::tracker-params db)))

(rf/reg-sub ::invalid-tracker-url-error-message
  :<- [::tracker-params]
  (fn [tracker-params [_ index]]
    (get-in tracker-params [index :error-message])))

(defn reduce-errors-to-tracker-params-effects [effects errors]
  (reduce (fn [effects {:keys [index type]}]
            (if (= type "variant-display-click-tracker-without-landing-macro")
              (mr/update-db effects assoc-in [::tracker-params index :error-message]
                            "A placeholder expression should contain '(:landing_url:)' or '(:landing_url_enc:)'.")
              effects)) effects errors))

(defn dissoc-errors-from-tracker-params [effects]
  (mr/update-db effects update ::tracker-params (partial mapv #(dissoc % :error-message))))

(rf/reg-sub ::redundant-click-tracker-indices
  :<- [::tracker-params]
  (fn [tracker-params _]
    (when-some [first-click-tracker-index (-> (for [[index {:keys [type]}] (mc/seq-indexed tracker-params)
                                                    :when (= type "click")]
                                                index)
                                              first)]
      (->> tracker-params
           (keep-indexed (fn [index {:keys [type]}]
                           (when (and (= type "click")
                                      (> index first-click-tracker-index))
                             index)))
           set))))

(rf/reg-sub ::only-1-click-tracker-error
  :<- [::redundant-click-tracker-indices]
  (fn [redundant-click-tracker-indices [_ index]]
    (contains? redundant-click-tracker-indices index)))

(rf/reg-sub ::can-save-trackers
  :<- [::redundant-click-tracker-indices]
  (fn [redundant-click-tracker-indices _]
    (empty? redundant-click-tracker-indices)))

(rf/reg-sub ::overridden-click-tracker-warning
  :<- [::tracker-params]
  :<- [:resource.feed-imports/field-classes]
  (fn [[tracker-params field-classes] [_ index]]
    (and (= (get-in tracker-params [index :type]) "click")
         (boolean (->> field-classes
                       (some (comp #{"third-party-click-tracker-key"} :class)))))))

(rf/reg-event-db ::add-tracker-param
  (fn [db _]
    (update db ::tracker-params (fnil conj []) {:type "click", :value nil})))

(rf/reg-event-db ::delete-tracker-param
  (fn [db [_ index]]
    (update db ::tracker-params util/vec-dissoc index)))

(rf/reg-event-db ::set-tracker-type
  (fn [db [_ index attribute]]
    (assoc-in db [::tracker-params index :type] attribute)))

(rf/reg-event-db ::set-tracker-value
  (fn [db [_ index value]]
    (assoc-in db [::tracker-params index :value] value)))
